import React, { useEffect, useState } from "react";

import "./EditBusiness.scss";
import CardView from "../../../components/molecules/CardView/CardView";
import { formatPrice } from "../../../utiles/Price";
import Input from "../../../components/atoms/Input/Input";

// Assets
import iconNombreEmpresa from "../../../assets/icons/icon_nombre_empresa_inact.png";

import ValidationMessage from "../../../components/atoms/ValidationMessage/ValidationMessage";
import Button from "../../../components/atoms/Button/Button";
import ButtonBack from "../../../components/atoms/ButtonBack/ButtonBack";
import iconTelefono from "../../../assets/icons/icon_telefono_inact.png";
import iconDireccion from "../../../assets/icons/icon_ubicacion_inact.png";
import iconPostalCode from "../../../assets/icons/icon_c_postal_inact.png";
import iconDiasGratis from "../../../assets/icons/icon_dia_gratis_inact.png";
import { validateData } from "../../../utiles/ValidateEntries";
import {
    getBranches,
    getBusinessById,
    getPlan,
    registerBranch,
    updateBussiness,
} from "../../../services/businnes";
import DataTable from "../../../components/organisms/DataTable/DataTable";
import AnimatedCard from "../../../components/molecules/AnimatedCard/AnimatedCard";
import { useParams } from "react-router-dom";
import { toast, Toaster } from "sonner";
import Map from "../../../components/organisms/Map/Map";
import FileUpload from "../../../components/atoms/FileUpload/FileUpload";
import Select from "../../../components/atoms/Select/Select";

// Opciones de días gratis
const FREE_DAYS_OPTIONS = [
    { id: 0, name: "Sin días gratis" },
    { id: 7, name: "7 días" },
    { id: 14, name: "14 días" },
    { id: 30, name: "30 días" },
    { id: 60, name: "60 días" },
    { id: 90, name: "90 días" },
    { id: 120, name: "120 días" },
    { id: 180, name: "180 días" },
    { id: 365, name: "1 año" },
    { id: 730, name: "2 años" },
    { id: -1, name: "Personalizado" },
];

const EditBusiness = () => {
    // CÓDIGO PARA AGREGAR UN NEGOCIO
    const { id } = useParams();
    const [businessName, setBusinessName] = useState("");
    const [myPlan, setMyPlan] = useState({});
    const [business, setBusiness] = useState({
        businessName: "",
        // owner: "",
        // email: "",
        phoneNumber: "",
        address: "",
        zipCode: "",
        // ticketMessage: "",
        // planId: "",
        freeDays: "",
    });
    // Estado para mantener los valores originales del negocio
    const [originalBusiness, setOriginalBusiness] = useState({});
    const [emptyField, setEmptyField] = useState({});
    const [showRightColumn, setShowRightColumn] = useState(true);
    const [plan, setPlan] = useState([]);
    const [imageFile, setImageFile] = useState(null);

    const getBusinessById_ = async () => {
        try {
            // const toastId = toast.loading("Procesando tu solicitud...", {
            //     position: "top-right",
            // });

            const response = await getBusinessById(id);

            console.log(response, "response");

            const businessData = {
                businessName: response.businessName || "",
                phoneNumber: response.phoneNumber || "",
                address: response.address || "",
                zipCode: response.zipCode || "",
                logo: response.logo || "",
                // ticketMessage: response.ticketMessage || "",
                freeDays: response.freeDays || "",
            };

            setBusiness(businessData);
            // Guardar valores originales para comparación posterior
            setOriginalBusiness(businessData);

            setBusinessName(response.businessName || "");

            setMyPlan(response.plans || {});
        } catch (error) {
            console.error("Error al obtener el negocio:", error);
            toast.error("Error al obtener el negocio", {
                position: "top-right",
            });
        }
    };

    useEffect(() => {
        getBusinessById_();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const formClear = () => {
    //     setBusiness({
    //         businessName: "",
    //         owner: "",
    //         email: "",
    //         phoneNumber: "",
    //         address: "",
    //         zipCode: "",
    //         ticketMessage: "",
    //         planId: "",
    //         freeDays: "",
    //     });
    // };

    const handleChange = (e) => {
        const { name, value } = e.currentTarget;
        setBusiness((prevent) => ({
            ...prevent,
            [name]: value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    // Manejador de cambios en selects
    const handleSelectChange = (name, value) => {
        setBusiness((prev) => ({
            ...prev,
            [name]: value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    // Manejador de cambio de imagen
    const handleImageChange = (file) => {
        setImageFile(file);
        console.log("Nueva imagen seleccionada:", file?.name);
    };

    const toggleColumn = () => {
        setShowRightColumn(!showRightColumn);
    };

    const getPlans = async () => {
        try {
            if (plan.length > 0) return; // Evita hacer la petición si ya se tienen los planes
            const response = await getPlan();
            setPlan(response);
        } catch (error) {
            console.error("Error al obtener los planes:", error);
        }
    };

    useEffect(() => {
        getPlans();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            // Mostrar toast de carga
            const toastId = toast.loading("Procesando tu solicitud...", {
                position: "top-right",
            });
            // Validación de datos

            console.log(business, "business");

            // Excluir 'logo' de la validación ya que es opcional y se maneja con imageFile
            const { status, emptyFields } = validateData(business, ["logo"]);
            setEmptyField(emptyFields);

            if (!status) {
                toast.error("Por favor, completa todos los campos requeridos", {
                    id: toastId,
                    position: "top-right",
                });
                return;
            }

            // Detectar campos que han cambiado
            const changedFields = {};
            let hasChanges = false;

            // Comparar cada campo con los valores originales
            Object.keys(business).forEach((key) => {
                // Excluir 'logo' de la comparación directa (lo manejamos con imageFile)
                if (key !== "logo" && business[key] !== originalBusiness[key]) {
                    changedFields[key] = business[key];
                    hasChanges = true;
                }
            });

            // Verificar si hay nueva imagen
            const hasNewImage = imageFile !== null;

            // Si no hay cambios en campos ni nueva imagen, no hacer nada
            if (!hasChanges && !hasNewImage) {
                toast.info("No se detectaron cambios para actualizar", {
                    id: toastId,
                    position: "top-right",
                });
                return;
            }

            // Preparar datos para envío
            let dataToSend;

            if (hasNewImage) {
                // Si hay nueva imagen, usar FormData y agregar todos los campos modificados
                const formData = new FormData();

                // Agregar solo los campos que cambiaron
                Object.keys(changedFields).forEach((key) => {
                    formData.append(key, changedFields[key]);
                });

                // Si no hubo cambios en campos de texto pero sí en imagen,
                // agregar al menos un campo para el contexto
                if (!hasChanges) {
                    formData.append("businessName", business.businessName);
                }

                // Agregar la nueva imagen con el nombre 'logo'
                formData.append("logo", imageFile, imageFile.name);
                dataToSend = formData;

                console.log("Enviando FormData con imagen:", {
                    campos: Object.keys(changedFields),
                    imagen: imageFile.name,
                });
            } else {
                // Si no hay nueva imagen, enviar solo los campos modificados como JSON
                dataToSend = changedFields;
                console.log("Enviando campos modificados:", changedFields);
            }

            // Actualización del negocio
            const response = await updateBussiness(id, dataToSend);

            if (!response.success) {
                throw new Error(
                    response.message ||
                        response.error ||
                        "Error al actualizar el negocio"
                );
            }

            // Actualizar valores originales después de una actualización exitosa
            setOriginalBusiness({ ...business });

            // Limpiar el archivo de imagen después de actualizarlo
            setImageFile(null);

            // Éxito
            toast.success("¡Actualización exitosa!", {
                description:
                    "Los datos del negocio se han actualizado correctamente.",
                position: "top-right",
                duration: 5000,
                icon: "✅",
                id: toastId,
            });

            // Recargar los datos actualizados del servidor
            await getBusinessById_();
        } catch (error) {
            console.error("Error en handleSubmit:", error);
            toast.error(
                error.message || "Ocurrió un error al procesar tu solicitud",
                {
                    position: "top-right",
                }
            );
        }
    };

    ///////////////////////////////////
    // CÓDIGO PARA AGREGAR UNA SUCURSAL
    ////////////////////////////////////
    const [branch, setBranch] = useState([]);
    const [loadingBranches, setLoadingBranches] = useState(false);
    const [addBranch, setAddBranch] = useState(false);
    const [coords, setCoords] = useState([]);
    const [searchBranch, setSearchBranch] = useState("");

    const [objBranch, setObjBranch] = useState({
        name: "",
        address: "",
        phoneNumber: "",
        whatsapp: "",
        digitalMenuAlias: "",
        digitalCardAlias: "",
        ticketMessage: "",
        description: "",
        latitude: "",
        longitude: "",
    });
    const [emptyBranch, setEmptyBranch] = useState({});

    const columns = [
        {
            field: "name",
            header: "Sucursal",
        },
        {
            field: "address",
            header: "Dirección",
        },
        {
            field: "phoneNumber",
            header: "Número de Teléfono",
        },
        {
            field: "whatsapp",
            header: "WhatsApp",
        },
    ];

    const eventChangeBranch = (e) => {
        const { name, value } = e.target;

        setObjBranch((prev) => ({
            ...prev,
            [name]: value,
        }));

        // // Si está escribiendo en el campo 'address', busca coordenadas
        // if (name === "address") {
        //     // Espera a que deje de escribir por unos ms
        //     debounceGeocode(value);
        // }

        setEmptyBranch((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const handleKeyDownAddress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Para evitar que se envíe el formulario si es un form
            const address = e.target.value;
            fetchCoords(address); // Llama a la función de geocodificación
        }
    };

    const fetchCoords = async (address) => {
        const apiKey = process.env.REACT_APP_LOCATION_API_KEY;

        const url = `https://us1.locationiq.com/v1/search.php?key=${apiKey}&q=${encodeURIComponent(
            address
        )}&format=json`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (Array.isArray(data) && data.length > 0) {
                const { lat, lon } = data[0];

                setCoords([parseFloat(lat), parseFloat(lon)]);

                setObjBranch((prev) => ({
                    ...prev,
                    latitude: parseFloat(lat),
                    longitude: parseFloat(lon),
                }));
            } else {
                console.warn("Dirección no encontrada:", address);
            }
        } catch (error) {
            console.error("Error al obtener coordenadas:", error);
        }
    };

    const handleAddBranch = async (e) => {
        e.preventDefault();

        try {
            // Validación de datos
            const { status, emptyFields } = validateData(objBranch);
            setEmptyBranch(emptyFields);

            if (!status) {
                toast.error(
                    "Por favor, completa todos los campos requeridos.",
                    {
                        position: "top-right",
                        autoClose: 5000,
                    }
                );
                return;
            }

            // Preparar datos
            const branchData = {
                ...objBranch,
                businessId: id, // Agregar el ID del negocio al objeto de la sucursal
            };
            // // Registrar sucursal
            // branchData.businessId = id;

            const response = await registerBranch(branchData);

            if (!response.success) {
                toast.info("Upss...", {
                    position: "top-right",
                    autoClose: 5000,
                    icon: "⚠️",
                    description:
                        response.message ||
                        response.error ||
                        "Error al registrar la sucursal",
                });

                return;
            }

            // Éxito
            toast.success("Sucursal agregada exitosamente", {
                position: "top-right",
                autoClose: 3000,
                icon: "✅",
            });

            // Resetear estado
            setAddBranch(false);
            setObjBranch({
                name: "",
                address: "",
                phoneNumber: "",
                whatsapp: "",
                description: "",
            });

            // Actualizar lista
            await getAllBranches();
        } catch (error) {
            console.error("Error en handleAddBranch:", error);

            toast.error(
                error.message || "Ocurrió un error al agregar la sucursal",
                {
                    position: "top-right",
                    autoClose: 5000,
                }
            );
        }
    };

    const [allBranches, setAllBranches] = useState([]);

    const getAllBranches = async () => {
        try {
            setLoadingBranches(true);
            const response = await getBranches(id);

            setBranch(response.data || []);
            setAllBranches(response.data || []);
        } catch (error) {
            console.error("Error al obtener las sucursales:", error);
            toast.error("Error al cargar las sucursales", {
                position: "top-right",
            });
        } finally {
            setLoadingBranches(false);
        }
    };

    useEffect(() => {
        const searchTerm = searchBranch.trim().toLowerCase();

        if (searchTerm.length > 1) {
            const filteredBranches = allBranches.filter((branch) =>
                branch.name.toLowerCase().includes(searchTerm)
            );
            setBranch(filteredBranches);
        } else {
            // Restablecer a todas las sucursales si la búsqueda es muy corta
            setBranch(allBranches);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchBranch]); // ← Añadimos allBranches como dependencia

    useEffect(() => {
        getAllBranches();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <CardView className="EditBusiness">
                <div className="EditBusiness__header">
                    <ButtonBack to="/business-list" />
                    <h1 className="EditBusiness__title">
                        {businessName ?? ""}
                    </h1>
                </div>

                <div className="editContainer">
                    <div className="editContainer__info">
                        {/* {bussines.map((item, idx) => {
                        return ( */}
                        <div
                            // key={idx}
                            className="editContainer__info__resume"
                        >
                            <div className="editContainer__info__resume__changeImage">
                                {/* <img src={business.logo} alt="Logotipo del negocio" /> */}

                                <FileUpload
                                    variant="card"
                                    accept="image/*"
                                    label="Cambiar Logotipo"
                                    onChange={handleImageChange}
                                    initialFile={business.logo}
                                    maxSize={5}
                                />
                            </div>
                            <div className="editContainer__info__resume__business">
                                <h4 className="editContainer__info__resume__business__title">
                                    Restaurante
                                </h4>
                                <div className="editContainer__info__resume__business__plan">
                                    <div className="editContainer__info__resume__business__plan__block">
                                        Plan
                                        <span className="editContainer__info__resume__business__plan__block__span">
                                            {myPlan.deviceCount ?? "-----"}
                                        </span>
                                    </div>
                                    <div className="editContainer__info__resume__business__plan__block">
                                        Precio MXN
                                        <span className="editContainer__info__resume__business__plan__block__span">
                                            {formatPrice(myPlan.cost ?? 0)}
                                        </span>
                                    </div>
                                    <div className="editContainer__info__resume__business__plan__block">
                                        Dispositivos
                                        <span className="editContainer__info__resume__business__plan__block__span">
                                            {myPlan.deviceCount ?? "-----"}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* );
                    })} */}
                        <form
                            onSubmit={handleSubmit}
                            className={`editContainer__info__form ${
                                showRightColumn ? "visible" : "hidden"
                            }`}
                        >
                            <ValidationMessage
                                show={emptyField.businessName}
                                className="editContainer__info__form__validation"
                            >
                                <Input
                                    type="text"
                                    name={"businessName"}
                                    text={"Nombre del negocio"}
                                    icon={iconNombreEmpresa}
                                    value={business.businessName}
                                    show={emptyField.businessName}
                                    onChange={handleChange}
                                />
                            </ValidationMessage>
                            {/* <ValidationMessage
                            show={emptyField.owner}
                            className="editContainer__info__form__validation"
                        >
                            <Input
                                type="text"
                                text={"Nombre del dueño"}
                                name={"owner"}
                                icon={iconNombreAgente}
                                value={business.owner}
                                show={emptyField.owner}
                                onChange={handleChange}
                            />
                        </ValidationMessage> */}
                            {/* <ValidationMessage
                            show={emptyField.email}
                            className="editContainer__info__form__validation"
                        >
                            <Input
                                type="email"
                                name="email"
                                text={"Correo de Usuario"}
                                value={business.email}
                                show={emptyField.email}
                                icon={iconCorreo}
                                onChange={handleChange}
                            />
                        </ValidationMessage> */}
                            <ValidationMessage
                                show={emptyField.phoneNumber}
                                className="editContainer__info__form__validation"
                            >
                                <Input
                                    type="number"
                                    name={"phoneNumber"}
                                    text={"Télefono"}
                                    value={business.phoneNumber}
                                    show={emptyField.phoneNumber}
                                    icon={iconTelefono}
                                    onChange={handleChange}
                                />
                            </ValidationMessage>
                            <ValidationMessage
                                show={emptyField.address}
                                className="editContainer__info__form__validation"
                            >
                                <Input
                                    type="text"
                                    text={"Dirección"}
                                    name={"address"}
                                    value={business.address}
                                    show={emptyField.address}
                                    icon={iconDireccion}
                                    onChange={handleChange}
                                />
                            </ValidationMessage>
                            <ValidationMessage
                                className="editContainer__info__form__validation"
                                show={emptyField.zipCode}
                            >
                                <Input
                                    name={"zipCode"}
                                    type="text"
                                    text={"Código postal"}
                                    value={business.zipCode}
                                    icon={iconPostalCode}
                                    show={emptyField.zipCode}
                                    onChange={handleChange}
                                />
                            </ValidationMessage>
                            <ValidationMessage
                                className="editContainer__info__form__validation"
                                show={emptyField.freeDays}
                            >
                                <Select
                                    text={"Días gratis"}
                                    name={"freeDays"}
                                    value={business.freeDays}
                                    setValue={(value) =>
                                        handleSelectChange("freeDays", value)
                                    }
                                    show={emptyField.freeDays}
                                    options={FREE_DAYS_OPTIONS}
                                    icon={iconDiasGratis}
                                />
                            </ValidationMessage>

                            <div className="editContainer__info__form__buttons">
                                <Button
                                    type={"submit"}
                                    text={"Actualizar"}
                                    className="degrad editContainer__info__form__buttons__btn"
                                />
                            </div>
                        </form>

                        <button
                            onClick={toggleColumn}
                            className="editContainer__info__toggle"
                        >
                            {showRightColumn ? "◄ Ocultar" : "Mostrar ►"}
                        </button>
                    </div>
                    <div className="editContainer__branch">
                        <div className="editContainer__branch__blockHeader">
                            <h4 className="editContainer__branch__blockHeader__title">
                                Sucursales
                            </h4>

                            <div className="editContainer__branch__blockHeader__divider">
                                <Input
                                    placeholder={"Buscar sucursal..."}
                                    onChange={(e) =>
                                        setSearchBranch(e.target.value)
                                    }
                                />

                                <Button
                                    text={"Agregar Sucursal"}
                                    onClick={() => setAddBranch(true)}
                                    className="outlet editContainer__branch__blockHeader__divider__btn"
                                />
                            </div>
                        </div>
                        <DataTable
                            data={branch}
                            columns={columns}
                            loading={loadingBranches}
                            emptyMessage="No se encontraron sucursales"
                        />
                    </div>
                </div>

                {addBranch && (
                    <AnimatedCard
                        setClose={setAddBranch}
                        title="Agregar Sucursal"
                        size="lg"
                        variant="elegant"
                        coloredHeader={true}
                    >
                        <form
                            onSubmit={handleAddBranch}
                            className="addBranch__content"
                        >
                            <div className="addBranch__content__left">
                                <ValidationMessage
                                    show={emptyBranch.name}
                                    errorClassName="no-margin"
                                >
                                    <Input
                                        id={"name"}
                                        name={"name"}
                                        type="text"
                                        placeholder={"Nombre de la sucursal"}
                                        onChange={eventChangeBranch}
                                        show={emptyBranch.name}
                                    />
                                </ValidationMessage>
                                <div>
                                    <ValidationMessage
                                        show={emptyBranch.address}
                                        errorClassName="no-margin"
                                    >
                                        <Input
                                            id={"address"}
                                            name={"address"}
                                            type="text"
                                            placeholder={
                                                "Dirección de la sucursal"
                                            }
                                            onChange={eventChangeBranch}
                                            show={emptyBranch.address}
                                            onKeyDown={handleKeyDownAddress}
                                        />
                                    </ValidationMessage>
                                    <div className="message_light">
                                        Presiona Enter para mostrar la dirección
                                        en el mapa.
                                    </div>
                                </div>
                                <div className="">
                                    <Map coords={coords} />
                                </div>

                                <ValidationMessage
                                    show={emptyBranch.phoneNumber}
                                    errorClassName="no-margin"
                                >
                                    <Input
                                        id={"phone_number"}
                                        name={"phoneNumber"}
                                        type="number"
                                        placeholder={"Teléfono de la sucursal"}
                                        show={emptyBranch.phoneNumber}
                                        onChange={eventChangeBranch}
                                    />
                                </ValidationMessage>
                                <ValidationMessage
                                    show={emptyBranch.whatsapp}
                                    errorClassName="no-margin"
                                >
                                    <Input
                                        id={"whatsapp"}
                                        name={"whatsapp"}
                                        type="number"
                                        show={emptyBranch.whatsapp}
                                        placeholder={
                                            "Teléfono de WhatsApp de la sucursal"
                                        }
                                        onChange={eventChangeBranch}
                                    />
                                </ValidationMessage>
                            </div>
                            <div className="addBranch__content__right">
                                <ValidationMessage
                                    show={emptyBranch.digitalMenuAlias}
                                    errorClassName="no-margin"
                                >
                                    <Input
                                        id={"digitalMenuAlias"}
                                        name={"digitalMenuAlias"}
                                        type="text"
                                        placeholder={"Alis del menu digital"}
                                        show={emptyBranch.digitalMenuAlias}
                                        onChange={eventChangeBranch}
                                    />
                                </ValidationMessage>
                                <ValidationMessage
                                    show={emptyBranch.digitalCardAlias}
                                    errorClassName="no-margin"
                                >
                                    <Input
                                        id={"digitalCardAlias"}
                                        name={"digitalCardAlias"}
                                        type="text"
                                        placeholder={
                                            "Alis de la tarjeta digital"
                                        }
                                        show={emptyBranch.digitalCardAlias}
                                        onChange={eventChangeBranch}
                                    />
                                </ValidationMessage>
                                <ValidationMessage
                                    show={emptyBranch.ticketMessage}
                                    errorClassName="no-margin"
                                >
                                    <Input
                                        id={"ticketMessage"}
                                        name={"ticketMessage"}
                                        type="text"
                                        placeholder={"Mensaje del ticket"}
                                        show={emptyBranch.ticketMessage}
                                        onChange={eventChangeBranch}
                                    />
                                </ValidationMessage>
                                <ValidationMessage
                                    show={emptyBranch.description}
                                    errorClassName="no-margin"
                                >
                                    <Input
                                        id={"description"}
                                        name={"description"}
                                        type="text"
                                        placeholder={
                                            "Descripción de la sucursal"
                                        }
                                        show={emptyBranch.description}
                                        onChange={eventChangeBranch}
                                    />
                                </ValidationMessage>
                                <Button
                                    // type={"button"}
                                    text={"Guardar"}
                                    className="degrad"
                                />
                            </div>
                        </form>
                    </AnimatedCard>
                )}

                <Toaster />
            </CardView>
        </>
    );
};

export default EditBusiness;
